export default __webpack_public_path__ + "static/media/AR-5.fbb20098.jpg";